import { watch, toValue } from "vue";
import { useAsyncData } from "@/shared/composables/useAsyncData";
import { getHousehold } from "../infrastructure/api/householdApi";
export function useHousehold(contactId) {
    const { data: household, loading, loadError, load, reload } = useAsyncData(() => getHousehold(toValue(contactId)));
    watch(() => toValue(contactId), load);
    return { household, loading, loadError, load, reload };
}
